<template>
  <div>
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception v-if="!loading && error"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-if="!loading && !error && person">
      <router-view name="studentIdentifierHeader" :person="person"/>
      <router-view
        name="studentIdentifierBody"
        :matches="matches"
        :matchesTotalCount="matchesTotalCount"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

export default {
  components: {
    EsException,
    EsLoader,
  },
  props: {
    identifier: {
      type: String,
      required: true,
    },
  },
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      error: null,
      loading: true,
      matchesTotalCount: null,
      person: null,
      matches: [],
    };
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch'} },
      { text: 'Person Information', to: {} },
    ]);
    this.onLoad();
  },
  methods: {
    async onLoad() {
      try {
        this.loading = true;
        const res = await this.loadPerson();

        this.matches = res.data.data;
        this.matchesTotalCount = res.data.totalCount;

        if (res.data.data.length) {
          this.person = res.data.data[0].nonStateStudent;
        }

      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    loadPerson() {
      return axios.get(`directmatch/studentmatch?id=${this.identifier}`);
    },
  },
}
</script>

<style lang="sass" scoped>
</style>
